
import {defer as observableDefer, Observable} from 'rxjs';
import {map, publishReplay, refCount, take} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {ServiceBase} from './service-base';
import {ISelectItemModel} from './interfaces/select-item.interface';
import {AuthHttpService} from '../auth/auth-http.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class LanguageService extends ServiceBase {
  private static ApiUrl = 'api/language';
  private data$: Observable<ISelectItemModel[]>;

  constructor(private http: HttpClient) {
    super();
  }

  public getSelectItems(): Observable<ISelectItemModel[]> {
    if (!this.data$) {
      const url = LanguageService.ApiUrl + '/list';

      this.data$ = observableDefer(() => this.http.get(url)).pipe(
        map((res: Response) => {
          const languages = (res || []) as ISelectItemModel[];
          return this.sortSelectItems(languages, 7); // 7 is the language_id of 'English-US'
        }),
        publishReplay(1),
        refCount(),
        take(1)
      );
    }

    return this.data$;
  }
}
